import * as React from 'react';
import $ from "jquery";
import Common from '../utilities/common';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

export interface ITipoViaDeleterops {
    open: boolean;
    onClose?: Function;
    onDelete?: Function;
    id: number[];
}

export interface ITipoViaDeleteState {
    open: boolean;
    hasErrors: boolean;
    errorMessage: string;
}

export default class TipoViaDelete extends React.Component<ITipoViaDeleterops, ITipoViaDeleteState> {
    _selectedItems: number[] = [];

    public constructor(props: ITipoViaDeleterops) {
        super(props);

        this.state = {
            open: false,
            hasErrors: false,
            errorMessage: ''
        }
    }

    componentWillReceiveProps(nextProps: Readonly<ITipoViaDeleterops>, nextContext: any): void {
        this._selectedItems = nextProps.id;

        this.setState({
            open: nextProps.open
        });
    }

    public render(): React.ReactElement<{}> {
        return (
            <Dialog open={this.state.open} fullWidth>
                <DialogTitle>
                    Eliminar tipo de vía
                </DialogTitle>
                <DialogContent>
                    {
                        this._selectedItems.length == 1 && (
                            `¿Desea eliminar el tipo de vía seleccionado?`
                        )
                    }
                    {
                        this._selectedItems.length > 1 && (
                            `¿Desea eliminar los tipos de vía seleccionados?`
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.Ok.bind(this)}>OK</Button>
                    <Button onClick={this.Close.bind(this)}>Cancelar</Button>
                </DialogActions>
            </Dialog>
        )
    }

    private Ok() {
        this.Delete(0);
    }

    private Close() {
        this.setState(
            {
                open: false,
                hasErrors: false,
                errorMessage: ''
            }
        );

        if(this.props.onClose != null) {
            this.props.onClose();
        }
    }

    private Delete(index: number): void {
        if(index >= this._selectedItems.length) {
            this.setState(
                {
                    open: false
                }
            );

            if(this.props.onDelete != null) {
                this.props.onDelete();
            }

            return;
        }

        let url = `${Common.END_POINT}/masters/tiposvia/${this._selectedItems[index]}/delete`;
        
        $.ajax((
            {
                url: url,
                type: "POST",
                data: this._selectedItems[index].toString(),
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.Delete(index + 1);
        })
    }
}